import PaymentAnalysisTab from '@components/dashboard/PaymentAnalysisTab';
import ServiceBasicStatisticsTab from '@components/dashboard/ServiceBasicStatisticsTab';
import UserBehaviorTab from '@components/dashboard/UserBehaviorTab';
import { useStatistics } from '@hooks/statistics';
import { utcTimeToLocalISOString } from '@utils/date';
import { DatePicker, DatePickerProps, Tabs } from 'antd';
import { Chart as ChartJS, registerables } from 'chart.js';
import dayjs from 'dayjs';
import React from 'react';
import './Dashboard.scss';

const { TabPane } = Tabs;

ChartJS.register(...registerables);

export const BACKGROUND_COLORS = [
  '#f69f8c',
  '#fef7ae',
  '#adb8f0',
  '#c5a0db',
  '#f6cb8b',
  '#acffb1',
  '#9b9df1',
  '#df97d2',
  '#85db8c',
  '#ffa4fd',
  '#9a80d5',
  '#8ac9a8',
  '#e58b82',
  '#cc8cb9',
  '#80d6f0',
  '#ddc9c3',
  '#ed81b4',
  '#9e80d6',
  '#d7d085',
  '#e3d3ab',
  '#f6dccb',
  '#adafe7',
  '#ed80f0',
  '#efb9d3',
  '#c5d2fe',
  '#80f8e6',
  '#c7b6ed',
  '#fbe9eb',
  '#f3e1ab',
  '#f49a9a',
];

// 차트용 색상 및 라벨 통일 상수 추가
export const CHART_CATEGORY_LABELS: { [key: string]: string } = {
  class: '클래스',
  commerce: '커머스',
  naver: '네이버',
  kakao: '카카오',
  ezwel: '이지웰',
  sum: '합계',
};

export const CHART_CATEGORY_COLORS: { [key: string]: string } = {
  class: '#FF3D8F', // 클래스 색상 변경
  commerce: '#7950EF', // 커머스 색상 변경
  naver: '#19ce60', // 네이버 녹색
  kakao: '#fee500', // 카카오 노랑
  ezwel: '#0D6EFD', // 이지웰 파랑
  sum: '#424242', // 진회색
};

export const CHART_MISC_LABELS: { [key: string]: string } = {
  user: '사용자',
  session: '세션',
  view: '뷰',
};
export const CHART_MISC_COLORS: { [key: string]: string } = {
  user: '#00B8D9', // 사용자
  session: '#FFAB00', // 세션
  view: '#36B37E', // 뷰
};

export const Dashboard: React.FC = () => {
  const { statisticsStore } = useStatistics();

  const onChangeStartDate: DatePickerProps['onChange'] = (date) => {
    statisticsStore.setStartDate(date ? new Date(date.toISOString()) : new Date(), { timeToZero: true });
  };

  const onChangeEndDate: DatePickerProps['onChange'] = (date) => {
    statisticsStore.setEndDate(date ? new Date(date.toISOString()) : new Date(), { timeToZero: true });
  };

  return (
    <div className="dashboard">
      <div className="page-header">
        <div>대시보드</div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <div>
            <DatePicker
              onChange={onChangeStartDate}
              value={dayjs(utcTimeToLocalISOString(statisticsStore.startDate))}
            />
          </div>
          <div style={{ marginLeft: '8px' }}>
            <DatePicker onChange={onChangeEndDate} value={dayjs(utcTimeToLocalISOString(statisticsStore.endDate))} />
          </div>
        </div>
      </div>
      <div className="page-content" style={{ padding: 0 }}>
        <Tabs defaultActiveKey="overview" size="large">
          <TabPane tab="서비스 기본 통계" key="overview">
            <ServiceBasicStatisticsTab />
          </TabPane>

          <TabPane tab="결제/판매 분석" key="payment">
            <PaymentAnalysisTab />
          </TabPane>

          <TabPane tab="유저 행동 분석" key="behavior">
            <UserBehaviorTab />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default Dashboard;
